import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      minHeight: '100vh'
    },
    errorContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignContent: 'flex-start'
    },
    errorCode: {
      alignSelf: 'flex-start',
      marginRight: theme.spacing(6)
    },
    errorDescription: {
      alignSelf: 'flex-start',
      fontWeight: 500,
      textAlign: 'left',
      '& > h1': {
        marginBottom: '20px',
        fontSize: '50px'
      }
    },
    actionButton: {
      marginRight: theme.spacing(2)
    }
  });
